export default __webpack_public_path__ + "cdb849e2e38d1e8f1aa6ac285b63e1a3.mp3";